import React from 'react';
import PropTypes from 'prop-types';

import AuthLayout from '@dashboard/layouts/AuthLayout';

import { FormElement, FormSubmit, Label, TextInput } from '@dashboard/components/Form';
import Link from '@dashboard/components/Link';
import Meta from '@dashboard/components/Meta';
import { appUrl } from '@/dashboard/services/env';

const propTypes = {
  form: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const AccountForgotPassword = props => {
  const { form, handleInputChange, handleSubmit } = props;

  return (
    <>
      <Meta
        meta={{
          title: 'Forgot password',
        }}
      >
        <link rel="canonical" href={`${appUrl}/forgot-password`} />
      </Meta>

      <AuthLayout>
        <div className="text-center">
          <h1 className="text-4xl">Reset your password</h1>
          <h3 className="text-lg mt-2 font-normal mb-4">
            Enter your email to receive a reset link
          </h3>
        </div>

        <div className="py-4">
          <form onSubmit={e => handleSubmit(e)}>
            <FormElement>
              <Label htmlFor="email">Email</Label>
              <TextInput
                id="email"
                name="email"
                type="email"
                border
                placeholder="Email"
                value={form.state.email}
                onChange={e => handleInputChange(e)}
                autocomplete="username"
                required
              />
            </FormElement>

            {form.saved && !form.message && (
              <FormElement>
                <p>A password reset link has been sent to your email address.</p>
              </FormElement>
            )}

            {form.message && <FormElement>{form.message}</FormElement>}

            <FormSubmit>
              <FormSubmit.Button size="full">Send reset email</FormSubmit.Button>
            </FormSubmit>
          </form>
        </div>

        <div className="mt-4 text-center">
          <Link href="/login" variant="secondary">
            Back to login
          </Link>
        </div>
      </AuthLayout>
    </>
  );
};

AccountForgotPassword.propTypes = propTypes;

export default AccountForgotPassword;
